import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import InlineSVG from 'svg-inline-react'
import Bubble from './Bubble'
import iconEvent from 'assets/icons/ico-event.svg'
import iconTime from 'assets/icons/ico-time.svg'
import iconDial from 'assets/icons/icon-action-phone-dial.svg'
import iconHangup from 'assets/icons/icon-action-phone-hangup.svg'
import iconCall from 'assets/icons/icon-action-phone-start.svg'

const InlineSmallIcon = styled(InlineSVG)`
  transform: scale(.6);  
`

const PhoneIcon = styled(InlineSmallIcon)`
  border-radius: 50%;
  background-color: #90A1B0;
  padding: 16px;
`

const ActionContainer = styled.div`
  width: 100%;
  height: 100%;
  display:flex;
  align-items:center;
  justify-content:flex-start;
`

const ActionWidget = ({action, avatar, isLeft, payload, endOfBlock, createdAt}) => {
  switch (action) {
    case 'phone_hangup': return <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='85.5%'
      timestamp={createdAt}
      stampStyle='text'
    >
      <ActionContainer>
        <PhoneIcon src={iconHangup} />
        { ' Call is over' }
      </ActionContainer>
    </Bubble>
    case 'phone_dial': return <Bubble
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
      width='85.5%'
      timestamp={createdAt}
      stampStyle='text'
    >
      <ActionContainer>
        <PhoneIcon src={iconDial}  />
        { ' Call to user' }
      </ActionContainer>
    </Bubble>
    case 'event':
      return <Bubble 
        isLeft={isLeft}
        avatar={avatar}
        endOfBlock={endOfBlock}
        width='85.5%'
        timestamp={createdAt}
        stampStyle='text'
      >
        {
          payload.name === 'SYS_PHONE_CALL'
            ? ( 
              <ActionContainer>
                <PhoneIcon src={iconCall} />
                {' The user started phone call'}
              </ActionContainer>)
            : (
              <ActionContainer>
                <InlineSmallIcon src={iconEvent} />
                {`The user triggered an event "${payload.label || payload.name}"`}
              </ActionContainer>
            )
        }
       
      </Bubble>
    case 'nothing':
      return <Bubble
        isLeft={isLeft}
        avatar={avatar}
        endOfBlock={endOfBlock}
        width='20%'
        timestamp={createdAt}
        stampStyle='text'
      >
        <InlineSmallIcon src={iconTime} />
      </Bubble>
    case 'trigger':
      return <Bubble
        isLeft={isLeft}
        avatar={avatar}
        endOfBlock={endOfBlock}
        width='85.5%'
        timestamp={createdAt}
        stampStyle='text'
      >
        <ActionContainer>
          <InlineSmallIcon src={iconTime} />
          { ' The system triggered an event…' }
        </ActionContainer>
      </Bubble>
    default: return null
  }
}

ActionWidget.propTypes = {
  action: PropTypes.string.isRequired,
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date).isRequired
}

export default ActionWidget
